import { pnlFor } from './positionMachine';

export function clipTradeToPlayhead(trade, playheadIndex) {
  if (!trade || trade.entryIndex > playheadIndex) return null;
  const exits = (trade.exits || []).filter((e) => e.index <= playheadIndex);
  const closedByPlayhead = trade.exitIndex != null && trade.exitIndex <= playheadIndex;
  if (closedByPlayhead) return { ...trade, exits };
  const filledQty = exits.reduce((s, e) => s + (Number(e.qty) || 0), 0);
  const remainingQty = Math.max(0, trade.qty - filledQty);
  const takeProfits = (trade.takeProfits || []).map((tp) => {
    if (tp.filledIndex == null || tp.filledIndex > playheadIndex) {
      return { ...tp, filledIndex: null, filledPrice: null, filledQty: 0 };
    }
    return { ...tp };
  });
  return {
    ...trade,
    exits,
    remainingQty,
    status: 'open',
    exitIndex: null,
    exitTime: null,
    exitPrice: null,
    exitReason: null,
    takeProfits,
    pnl: exits.reduce((s, e) => (
      s + pnlFor(trade.side, trade.entryPrice, e.price, e.qty, trade.pointValue)
    ), 0),
  };
}

export function tradesAtPlayhead(trades, playheadIndex) {
  return (trades || [])
    .map((t) => clipTradeToPlayhead(t, playheadIndex))
    .filter(Boolean);
}

export function openPositionAtPlayhead(trades, playheadIndex) {
  const visible = tradesAtPlayhead(trades, playheadIndex);
  return visible.find((t) => t.status === 'open') || null;
}

export function workingOrderAtPlayhead(orders, playheadIndex) {
  const i = Number(playheadIndex);
  if (!Number.isFinite(i)) return null;
  let found = null;
  for (const order of orders || []) {
    if (!order || order.type !== 'enter') continue;
    if (order.rejectReason) continue;
    if (!Number.isFinite(order.placedIndex) || order.placedIndex > i) continue;
    if (order.fillIndex != null && order.fillIndex <= i) continue;
    if (order.expireIndex != null && order.expireIndex <= i) continue;
    found = order;
  }
  return found;
}

/** Most recent size-rejected entry at or before the playhead (for criteria chips). */
export function skippedOrderAtPlayhead(orders, playheadIndex) {
  const i = Number(playheadIndex);
  if (!Number.isFinite(i)) return null;
  let found = null;
  for (const order of orders || []) {
    if (!order?.rejectReason) continue;
    if (!Number.isFinite(order.placedIndex) || order.placedIndex > i) continue;
    if (Number.isFinite(order.expireIndex) && order.expireIndex > i) continue;
    found = order;
  }
  return found;
}

export function clampPlayhead(index, barCount) {
  if (!barCount) return 0;
  const i = Number(index);
  if (!Number.isFinite(i)) return barCount - 1;
  return Math.max(0, Math.min(barCount - 1, Math.floor(i)));
}

export const REPLAY_SPEEDS = [1, 2, 5, 10];

export function replayIntervalMs(speed) {
  const s = Number(speed) || 1;
  return Math.max(40, Math.round(280 / s));
}
